module.exports = "/static/assets/3aec74140126f59247a5513ff0541125.png";